import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFIconProps } from './IconProps'

export function ActivityIcon(iconProps: EFIconProps) {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'

  return (
    <svg
      width={iconProps.width}
      height={iconProps.height}
      viewBox={`0 0 ${iconProps.width} ${iconProps.height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.05402 19.9071C9.17734 20.0289 9.38021 20.0289 9.50353 19.9071L13.5531 15.9047L16.9782 19.2937C17.1015 19.4156 17.3044 19.4156 17.4277 19.2937L26.43 10.3886C26.5533 10.2667 26.5533 10.0662 26.43 9.94431L24.9661 8.49747C24.8427 8.37559 24.6399 8.37559 24.5165 8.49747L17.205 15.7317L13.7799 12.3426C13.6566 12.2207 13.4537 12.2207 13.3304 12.3426L7.59011 18.016C7.46679 18.1378 7.46679 18.3383 7.59011 18.4602L9.05402 19.9071V19.9071Z'
        fill={fill}
      />
      <path
        d='M32.5997 2.94209H18.4379V0.425843C18.4379 0.252852 18.2947 0.111313 18.1197 0.111313H15.892C15.717 0.111313 15.5738 0.252852 15.5738 0.425843V2.94209H1.41206C0.707955 2.94209 0.139099 3.50431 0.139099 4.20021V24.6447C0.139099 25.3406 0.707955 25.9028 1.41206 25.9028H15.5897V27.1609L9.03393 31.411C8.88674 31.5054 8.84696 31.698 8.94244 31.8435L10.1478 33.6992V33.7032C10.2432 33.8486 10.4421 33.888 10.5893 33.7936L17.0059 29.6339L23.4224 33.7936C23.5696 33.888 23.7685 33.8486 23.864 33.7032V33.6992L25.0693 31.8435C25.1648 31.698 25.121 31.5054 24.9778 31.411L18.4379 27.1727V25.9028H32.5997C33.3038 25.9028 33.8726 25.3406 33.8726 24.6447V4.20021C33.8726 3.50431 33.3038 2.94209 32.5997 2.94209ZM31.0085 23.072H3.00327V5.77286H31.0085V23.072Z'
        fill={fill}
      />
    </svg>
  )
}
